module.exports = __webpack_public_path__ + "img/triangle-0.792c8f11.gif";